import type { GetInteractor } from '@coris-ts/repository/interactor/get.interactor'
import { GetSubscriberIntervalsQuery } from '../../data/queries/get-subscriber-intervals.query'
import { type SubscriberIntervals } from '../models/subscriber-intervals'
import type { Resolution } from '../models/range'

export class GetSubscriberIntervalsInteractor {
  constructor(private readonly getSubscriberIntervals: GetInteractor<SubscriberIntervals>) {}

  public async execute(
    fromDate: string,
    toDate: string,
    resolution: Resolution,
    organization: string
  ): Promise<SubscriberIntervals> {
    return await this.getSubscriberIntervals.execute(
      new GetSubscriberIntervalsQuery(fromDate, toDate, resolution, organization)
    )
  }
}
